<template>
  <el-popover
      v-model="open"
      placement="right"
      width="380">
    <!-- REQUEST AUTH -->
    <div
        v-if="isRequestForm"
        style="margin: 15px;">
      <div>
        <div>
          Select a verification method
        </div>
        <br>
        <el-select
            v-model="selected_channel"
            placeholder=""
            size="small">
          <el-option
              v-for="ch in channels"
              :key="ch"
              :label="ch"
              :value="ch" />
        </el-select>
      </div>
      <div
          v-if="selected_channel === 'SMS'"
          style="margin: 15px;">
        <div>
          <ul class="authorization__list">
            <li>
              Make sure the phone number is <br>
              correct.
            </li>
            <li>
              {{ tfa_phone_number }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--ACCEPT AUTH CODE -->

    <el-form
        v-else
        ref="acceptAuth"
        v-loading="posting"
        class="customer-auth-request-form"
        label-position="top"
        style="margin: 0 17px 0"
        :rules="acceptAuth.rules"
        :model="acceptAuth">
      <el-form-item
          prop="code"
          label="Verify the code">
        <el-input
            v-model="acceptAuth.code"
            size="small"
            placeholder="Authorization Code"
            @keydown.enter.native.prevent="submitForm" />
      </el-form-item>
    </el-form>
    <!--ERROR-->
    <el-row v-if="true">
      <el-alert
          v-for="error in errors"
          :key="error"
          :title="error"
          type="error"
          style="margin-bottom: 15px"
          show-icon />
    </el-row>

    <!--BUTTONS-->
    <div style="text-align: right; margin: 0">
      <el-button
          :disabled="posting"
          size="mini"
          type="text"
          @click="closeForm">
        Cancel
      </el-button>
      <el-button
          :disabled="showAcceptCodeForm && emptyCode || !showAcceptCodeForm && !selected_channel"
          type="primary"
          size="mini"
          @click="submitForm">
        <i
            v-show="posting"
            class="el-icon-loading"></i>
        {{ isRequestForm ? 'Request' : 'Accept' }}
      </el-button>
    </div>

    <!--OPEN POPOVER BTN-->

    <el-button
        slot="reference"
        style="padding: 0;"
        size="small"
        type="text"
        :disabled="disabled">
      <span v-if="$attrs['btn-label']"> {{ $attrs['btn-label'] }}</span>
      <slot
          v-else
          name="btn-label"></slot>
    </el-button>
  </el-popover>
</template>

<script>
import axios from "axios";
import { get, includes, isEmpty } from "lodash";
import permission from "@/mixins/permission";
import { createNamespacedHelpers } from "vuex";
import * as types from "../../../modules/action-types";
import { lowerCase } from "lodash/string";

const { mapGetters } = createNamespacedHelpers("db/account");

const REQUEST_AUTH = "request-auth";
const ACCEPT_CODE = "accept-code";

export default {
  name: "NewRingAuthRequest",
  mixins: [permission],
  props: {
    formAction: {
      type: String,
      default: REQUEST_AUTH,
      validator: function (value) {
        // The value must match one of these values
        return [REQUEST_AUTH, ACCEPT_CODE].indexOf(value) !== -1;
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      action: this.formAction,
      open: false,
      posting: false,
      errors: [],
      isRequestForm: this.action === ACCEPT_CODE ? false : true,
      acceptAuth: {
        code: "",
        rules: {
          code: [
            {
              required: true,
              message: "This fields is required",
              trigger: "change",
            },
          ],
        },
      },
      labelPosition: "top",
      selected_channel: "",
    };
  },
  computed: {
    mailToOwnerEmail() {
      return `mailto:${this.email}`;
    },
    hasErrors() {
      return this.errors.length > 0;
    },
    showAcceptCodeForm() {
      return !this.isRequestForm;
    },
    emptyCode() {
      return isEmpty(this.acceptAuth.code.trim());
    },
    formName() {
      return this.showAcceptCodeForm ? "acceptAuth" : "requestAuth";
    },
    channels() {
      console.log("In verification channels");
      return this.tfa_phone_number.length > 8 && this.allow_sms
        ? ["SMS", "Email"]
        : ["Email"];
    },
    ...mapGetters([
      "email",
      "customerId",
      "phone_number",
      "tfa_phone_number",
      "allow_sms",
    ]),
  },
  mounted() {
    console.log("In mounted");
    console.log(this.channels);
    this.selected_channel = this.channels[0];
  },
  created() {
    console.log("In updated");
    console.log(this.channels);
    this.selected_channel = this.channels[0];
  },
  updated() {
    console.log("In updated NewRingAuthRequest");
    this.isRequestForm = this.action === ACCEPT_CODE ? false : true;
    if (this.selected_channel === "") {
      this.selected_channel = this.channels[0];
    }
  },
  methods: {
    loadVerification() {
      console.log("In loadVerification");
      this.selected_channel = this.channels[0];
    },
    submitForm() {
      if (this.isRequestForm) {
        // Nothing to validate.
        this.requestAuthorization();
        this.isRequestForm = false;
        return;
      }
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          this.requestAuthorization();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      // this.resetForm();
      this.open = false;
      Object.assign(this.$data, this.$options.data(), {
        action: this.$props.formAction,
      });
    },
    resetForm() {
      this.$refs[this.formName].resetFields();
    },

    /*
    POST  /v2/customers/{customer_id}/personal_identifiable_information
    PUT   /v2/customers/{customer_id}/personal_identifiable_information?code[code]
    * */
    requestAuthorization() {
      let request,
        payload = {};
      this.posting = true;
      if (this.showAcceptCodeForm) {
        payload = {
          code: get(this, "acceptAuth.code", null),
        };
        request = this.acceptAuthCode.bind(this);
      } else {
        payload = {
          channel: lowerCase(get(this, "selected_channel", "email")),
        };
        request = this.requestPIIAuthorization.bind(this);
      }
      request(payload).finally(() => {
        this.posting = false;
      });
    },
    requestPIIAuthorization(payload) {
      return axios
        .post(
          `v2/customers/${this.customerId}/personally_identifiable_information.json`,
          payload
        )
        .then((response) => {
          this.$emit("on-requested", response.data);
          this.$notify({
            title: "Success",
            message: "Pending for approval",
            type: "success",
          });
          this.closeForm();
        })
        .catch((error) => {
          this.processErrors(error);
        });
    },
    acceptAuthCode(payload) {
      return axios
        .put(
          `v2/customers/${this.customerId}/personally_identifiable_information.json`,
          payload
        )
        .then((response) => {
          this.$notify({
            title: "Success",
            message: "Browser will reload shortly!",
            type: "success",
          });
          this.$emit("on-accepted", response.data);
          this.closeForm();
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          this.processErrors(error);
        });
    },
    processErrors(error) {
      if (error instanceof String) {
        console.error(error);
      }
      if (error.data.message) {
        this.errors = [error.data.message];
      } else {
        this.errors = Object.keys(error.data || {}).map((f) => {
          let msg = error.data[f];
          msg = msg instanceof Array ? msg.join(", ") : msg;
          return `${f}: ${msg}`;
        });
      }
    },
  },
};
</script>

<style lang="scss">
.request-auth-content strong {
  font-size: small;
  color: $--color-dusty-gray;
}
.customer-auth-request-form {
  .el-radio-group {
    label[role="radio"].el-radio {
      margin: 0 0 15px !important;
      display: block;
    }
  }
  .el-form-item .el-form-item__label {
    font-size: $--font-size-small !important;
  }
}

ul.authorization__list {
  list-style-type: none;
  padding-inline-start: 0px;
}
</style>
